export default () => ({
  queue: null,
  queueListener: null,
  updatedAt: null
})
